import { AfterContentInit, Component, ContentChildren, Input, OnInit, QueryList, TemplateRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FilterField } from '../../../types/filterField.type';
import { Filters } from '../../../types/filters.type';
import { Flags } from '../../../types/flags.type';
import { MuFilterToolbarFieldDirective } from '../directives/mu-filter-toolbar-field.directive';
import { MuFilterToolbarFieldLabelDirective } from '../directives/mu-filter-toolbar-field-label.directive';
import { FiltersToolbarAccessor } from '../models/filtersToolbarAccessor.interface';

@Component({
  selector: 'app-mu-filter-toolbar',
  templateUrl: './mu-filter-toolbar.component.html',
  styleUrls: ['./mu-filter-toolbar.component.sass'],
})
export class MuFilterToolbarComponent<DataFilters, FlagType>
  implements OnInit, AfterContentInit, FiltersToolbarAccessor<DataFilters, FlagType>
{
  @Input() flagList: Flags<FlagType>;
  @Input() showFlag: FlagType;
  @Input() buttonLoaderFlag: FlagType;
  @Input() filterList: Filters<DataFilters>;
  @Input() filterFieldList: FilterField<DataFilters>[];
  @Input() sideBarTitle: string;
  @Input() descriptionFilter: string;
  @ContentChildren(MuFilterToolbarFieldDirective) filterTemplateList: QueryList<MuFilterToolbarFieldDirective>;
  @ContentChildren(MuFilterToolbarFieldLabelDirective) filterLabelTemplateList: QueryList<MuFilterToolbarFieldLabelDirective>;
  modalFilterList: Filters<DataFilters>;
  loopScrollX: any;

  constructor(private translateService: TranslateService) {
    /** */
  }

  ngOnInit(): void {
    this.modalFilterList = this.filterList?.clone;
  }

  ngAfterContentInit(): void {
    const filterTemplateMap: { [key: string]: TemplateRef<any> } = {};
    const filterLabelTemplateMap: { [key: string]: TemplateRef<any> } = {};
    this.filterTemplateList?.forEach(element => {
      filterTemplateMap[element.name || ''] = element.template;
    });
    this.filterLabelTemplateList?.forEach(element => {
      filterLabelTemplateMap[element.name || ''] = element.template;
    });
    this.filterFieldList?.forEach(element => {
      element.filterTemplate = filterTemplateMap[element.filter as string] || filterTemplateMap[''];
      element.labelTemplate = filterLabelTemplateMap[element.filter as string] || filterLabelTemplateMap[''];
      element.filters = this.modalFilterList;
    });
  }

  /**
   * Gets the toolbar component
   */
  getFilterToolBar(): MuFilterToolbarComponent<DataFilters, FlagType> {
    return this;
  }

  /**
   * show side bar
   */
  showSideBar(): void {
    this.modalFilterList?.update(this.filterList.filterData);
    this.flagList.enable(this.showFlag);
  }

  /**
   * get tooltip text
   */
  getTooltipText(filterField: FilterField<DataFilters>): string {
    return !filterField.optionsLength ? filterField.getLabel(this.filterList.filterData) : '';
  }

  /**
   * get translated label
   * @param {FilterField} filterField
   * @param {string} label
   * @return {string} response
   */
  getTranslatedLabel(filterField: FilterField<DataFilters>): string {
    const label = filterField.getLabel(this.filterList.filterData, this.getAllLabel(filterField.filter.toString() + ''));
    if (!filterField.optionsLength || typeof label === 'string') {
      return label;
    }
    return this.translateService.instant('form.label.filterToolbar.' + filterField.filter.toString(), { amount: label });
  }

  /**
   * get all label translated
   * @param label
   * @return {string} response
   */
  getAllLabel(label: string): string {
    return this.translateService.instant('form.label.all.' + label);
  }

  /**
   * is valid filter value
   * @param filterField
   */
  isValidFilterValue(filterField: FilterField<DataFilters>): boolean {
    const label = this.getTranslatedLabel(filterField);
    return label && label !== '' && !(label + '').includes('{{ amount }}');
  }

  /**
   * scroll x on click
   * @param {boolean} left
   */
  scrollX(left?: boolean): void {
    this.loopScrollX = setInterval(() => {
      const element = document.getElementById('mu-filter-toolbar-items');
      if (element && element.scrollLeft) {
        element.scrollLeft += left ? -45 : 45;
      }
    }, 100);
  }

  /**
   * stop scroll x interval
   */
  stopScrollX() {
    clearInterval(this.loopScrollX);
  }
}
